import { GPQClient, LuxedoClient } from "./src/LuxedoClient"

const LuxedoRPC = new LuxedoClient()

export { LuxedoRPC, GPQClient, type LuxedoClient }
export { RPCError } from "rpc-client"
